import StyledLink from '../StyledLink'
import useModule from '../../hooks/useModule'
import {
  CONTROLLER,
  MONITOR,
  RESULTS
} from '../routes'
import { PROP_TASK_INSTANCE_ID } from '../constants'
import type { Props } from '../types'

interface Params {
  [PROP_TASK_INSTANCE_ID]: string
}

const LinkToRunResults = ({
  children,
  [PROP_TASK_INSTANCE_ID]: taskInstanceId,
  isHyperlink
}: Props & Params) => {
  const [isMonitorFlag] = useModule()

  const base = !isMonitorFlag
    ? '/' + CONTROLLER + '/' + RESULTS
    : '/' + MONITOR + '/' + RESULTS

  return (
    <StyledLink
      isHyperlink={isHyperlink}
      to={base + '/runs/' + taskInstanceId}
    >
      {children}
    </StyledLink>
  )
}

export default LinkToRunResults
